import { render, staticRenderFns } from "./AddContentSectionComponent.vue?vue&type=template&id=2c39c2d8&scoped=true"
import script from "./AddContentSectionComponent.vue?vue&type=script&lang=js"
export * from "./AddContentSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39c2d8",
  null
  
)

export default component.exports